module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "template template--basic"
  }, [(_vm.isVerifying) ? _c('loading', {
    attrs: {
      "alt": true
    }
  }) : _c('div', {
    staticClass: "login"
  }, [_c('header', {
    staticClass: "login__header"
  }, [_c('h1', [_vm._v("De laatste stap!")]), _c('p', [_vm._v("Jouw account is bijna klaar. Vul nog even je naam in en het wachtwoord waarmee je de volgende keer kunt inloggen.")])]), _c('div', {
    staticClass: "login__panel-wrap"
  }, [_c('div', {
    staticClass: "login__panel"
  }, [_c('form', {
    staticClass: "login__form"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "label--disabled",
    attrs: {
      "for": "email"
    }
  }, [_vm._v("E-mail")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "text",
      "name": "email",
      "id": "email",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.submit($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _c('hr'), _c('div', {
    staticClass: "input-group",
    class: {
      error: _vm.containsError('firstname')
    }
  }, [_c('label', {
    attrs: {
      "for": "firstname"
    }
  }, [_vm._v("Voornaam")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstname),
      expression: "firstname"
    }],
    attrs: {
      "type": "text",
      "name": "firstname",
      "id": "firstname",
      "autofocus": !_vm.isTouch
    },
    domProps: {
      "value": (_vm.firstname)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.submit($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.firstname = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "input-group",
    class: {
      error: _vm.containsError('infix')
    }
  }, [_c('label', {
    attrs: {
      "for": "infix"
    }
  }, [_vm._v("Tussenvoegsel "), _c('span', {
    staticClass: "example"
  }, [_vm._v("— de / van / van 't / van den /  ...")])]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.infix),
      expression: "infix"
    }],
    attrs: {
      "type": "text",
      "name": "infix",
      "id": "infix"
    },
    domProps: {
      "value": (_vm.infix)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.submit($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.infix = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "input-group",
    class: {
      error: _vm.containsError('lastname')
    }
  }, [_c('label', {
    attrs: {
      "for": "lastname"
    }
  }, [_vm._v("Achternaam")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lastname),
      expression: "lastname"
    }],
    attrs: {
      "type": "text",
      "name": "lastname",
      "id": "lastname"
    },
    domProps: {
      "value": (_vm.lastname)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.submit($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lastname = $event.target.value
      }
    }
  })]), _c('hr'), _c('div', {
    staticClass: "input-group",
    class: {
      error: _vm.containsError('password')
    }
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Wachtwoord "), _c('span', {
    staticClass: "example"
  }, [_vm._v("— minimaal 8 tekens")])]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "name": "password",
      "id": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.submit($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "input-group",
    class: {
      error: _vm.containsError('passwordConfirmation')
    }
  }, [_c('label', {
    attrs: {
      "for": "passwordConfirmation"
    }
  }, [_vm._v("Herhaal wachtwoord")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passwordConfirmation),
      expression: "passwordConfirmation"
    }],
    attrs: {
      "type": "password",
      "name": "passwordConfirmation",
      "id": "passwordConfirmation"
    },
    domProps: {
      "value": (_vm.passwordConfirmation)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.submit($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.passwordConfirmation = $event.target.value
      }
    }
  })]), _c('primary-button', {
    attrs: {
      "link": {
        name: 'root'
      },
      "loading": _vm.loading
    },
    on: {
      "clicked": _vm.submit
    }
  }, [_vm._v("Naar de werkmap")])], 1)])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66e954e2","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/auth/RegisterVerify.vue
// module id = O3kh
// module chunks = 1